export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11913.b4924ea6.jpg";